import { Typography } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';
import { useAppSelector } from 'shared/redux/store';
import AuditionItem from '../AuditionItem/AuditionItem';
import { AuditionItemsContainer, Heading } from '../Audtion.styles';
import LoadingCont from '../LoadingCont';
import { MainCont, NoData } from './UpcomingAuditions.styles';

interface Props {
  data: IAuditionSchedulesAttributes[];
  isLoading: boolean;
}

interface IResult {
  [key: string]: IAuditionSchedulesAttributes[];
}

const UpcomingAuditions: React.FC<Props> = ({ data, isLoading }) => {
  const dateFormater = (date: moment.MomentInput) => moment(date).format('M/D/yyyy').toString();
  const dateToday = dateFormater(moment());
  const dateTomorrow = dateFormater(moment().add(1, 'days'));
  const { user: userState } = useAppSelector((state: any) => state);
  const country = userState?.user?.attributes?.other_phone_numbers?.filter((num) => num.type === 'primary');
  const userCountry = country && country.length > 0 ? country[0].country_code.toLowerCase() : 'au';

  // Group the objects by date
  const groupedData = (data.length ? data : []).reduce((result: IResult, obj) => {
    const dte = obj.schedule?.time_in ? obj.schedule?.time_in : obj.checked_in_at;

    const checkinDate = dte ? new Date(dte.toString().slice(0, 19)) : 'Invalid Date';
    const timeZone = obj.schedule?.casting_session?.casting_location.address?.timezone;
    const Z = moment.tz(checkinDate, timeZone).format('z');

    const date = checkinDate.toLocaleString().split(',')[0];

    // const date = moment.utc(obj.schedule?.time_in || obj.checked_in_at).format(`dddd Do MMMM 'YY`);
    const updatedResult = { ...result }; // Create a new object based on 'result'

    if (!updatedResult[date]) {
      updatedResult[date] = [];
    }

    updatedResult[date].push(obj);
    return updatedResult;
  }, {});

  const dates = Object.keys(groupedData).filter((d) => d !== 'Invalid date');

  //use this to isolate the invalid dates

  const invalidDates = Object.keys(groupedData).filter((d) => d === 'Invalid date');

  const newDates = dates.concat(invalidDates).filter((f) => f !== dateToday && f !== dateTomorrow);

  return isLoading ? (
    <LoadingCont />
  ) : (
    // <MainCont>
    //   {dates.indexOf(dateToday) > -1 ? (
    //     <>
    //       <Heading>
    //         <Typography style={{ marginRight: 10, fontWeight: 600 }} color="primary">
    //           TODAY
    //         </Typography>
    //         {/* {dateToday} */}
    //       </Heading>
    //       <AuditionItemsContainer>
    //         {groupedData[dateToday].map((a) => (
    //           <AuditionItem data={a} />
    //         ))}
    //       </AuditionItemsContainer>
    //     </>
    //   ) : (
    //     <React.Fragment />
    //   )}
    //   {dates.indexOf(dateTomorrow) > -1 ? (
    //     <>
    //       <Heading>
    //         <Typography style={{ marginRight: 10, fontWeight: 600 }} color="primary">
    //           TOMORROW
    //         </Typography>
    //         {/* {dateTomorrow} */}
    //       </Heading>
    //       <AuditionItemsContainer>
    //         {groupedData[dateTomorrow].map((a) => (
    //           <AuditionItem data={a} />
    //         ))}
    //       </AuditionItemsContainer>
    //     </>
    //   ) : (
    //     <React.Fragment />
    //   )}
    //   {groupedData ? (
    //     <>
    //       {newDates.length ? (
    //         <Typography style={{ marginRight: 10, fontWeight: 600, marginTop: 20 }} color="primary">
    //           UPCOMING
    //         </Typography>
    //       ) : (
    //         <React.Fragment />
    //       )}

    //       {newDates
    //         .sort((a, b) => {
    //           return (new Date(b) as any) - (new Date(a) as any);
    //         })
    //         .reverse()
    //         .map((d: any) => (
    //           <>
    //             <Heading>{d === 'Invalid Date' ? 'Invalid Date' : moment(d).format(`dddd, Do MMMM 'YY`)}</Heading>
    //             <AuditionItemsContainer>
    //               {groupedData[d].map((a) => (
    //                 <AuditionItem data={a} />
    //               ))}
    //             </AuditionItemsContainer>
    //           </>
    //         ))}
    //     </>
    //   ) : (
    //     <React.Fragment />
    //   )}
    // </MainCont>
    <MainCont>
      {data.length > 0 ? (
        <>
          {dates.indexOf(dateToday) > -1 ? (
            <>
              <Heading>
                <Typography style={{ marginRight: 10, fontWeight: 600 }} color="primary">
                  TODAY
                </Typography>
                {/* {dateToday} */}
              </Heading>
              <AuditionItemsContainer>
                {groupedData[dateToday].map((a) => (
                  <AuditionItem country={userCountry} data={a} />
                ))}
              </AuditionItemsContainer>
            </>
          ) : (
            <React.Fragment />
          )}
          {dates.indexOf(dateTomorrow) > -1 ? (
            <>
              <Heading>
                <Typography style={{ marginRight: 10, fontWeight: 600 }} color="primary">
                  TOMORROW
                </Typography>
                {/* {dateTomorrow} */}
              </Heading>
              <AuditionItemsContainer>
                {groupedData[dateTomorrow].map((a) => (
                  <AuditionItem country={userCountry} data={a} />
                ))}
              </AuditionItemsContainer>
            </>
          ) : (
            <React.Fragment />
          )}
          {groupedData ? (
            <>
              {newDates.length ? (
                <Typography style={{ marginRight: 10, fontWeight: 600, marginTop: 20 }} color="primary">
                  UPCOMING
                </Typography>
              ) : (
                <React.Fragment />
              )}

              {newDates
                .sort((a, b) => {
                  return (new Date(b) as any) - (new Date(a) as any);
                })
                .reverse()
                .map((d: any) => (
                  <>
                    <Heading>{d === 'Invalid Date' ? 'Invalid Date' : moment(d).format(`dddd, Do MMMM 'YY`)}</Heading>
                    <AuditionItemsContainer>
                      {groupedData[d].map((a) => (
                        <AuditionItem country={userCountry} data={a} />
                      ))}
                    </AuditionItemsContainer>
                  </>
                ))}
            </>
          ) : (
            <React.Fragment />
          )}
        </>
      ) : (
        <NoData>No Data Available</NoData>
      )}
    </MainCont>
  );
};

export default UpcomingAuditions;
